import { IneligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";
import { MentalHealthPageData } from "./MentalHealthRoot";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { ProgrammeProps } from "../Props";

export interface MentalHealthIneligibleProps extends ProgrammeProps {
  mentalHealthPageData: MentalHealthPageData;
}

const MentalHealthIneligibleScreen: React.FC<MentalHealthIneligibleProps> = (
  props: MentalHealthIneligibleProps
) => {
  const { programmeTitle, mentalHealthPageData } = props;

  const ineligible_page_title = `Ineligible mental health | ${programmeTitle} | ${pageTitleSuffix}`;

  return (
    <IneligibleScreen
      title={ineligible_page_title}
      heading={mentalHealthPageData.ineligibleScreens.ineligibleMentalHealth.title}
      bodyText={mentalHealthPageData.ineligibleScreens.ineligibleMentalHealth.body}
      hasContactUs={true}
    />
  );
};

export default MentalHealthIneligibleScreen;
